"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonResponseParser = void 0;
var parse = function (text) {
    var responseData;
    try {
        responseData = JSON.parse(text);
    }
    catch (error) {
        responseData = null;
    }
    return Promise.resolve(responseData);
};
exports.jsonResponseParser = {
    parse: parse,
};
